import RichTextTables from './RichTextTables';

export default RichTextTables;
